import axios from "axios";
import { jwtDecode } from "jwt-decode";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast"; //toast import
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logoLarge.png"; // Replace with your logo path
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [timer, setTimer] = useState(10);

  // Ref to hold the countdown interval, to manage clearing it properly
  const countdownRef = useRef(null);

  // Check authentication on mount only
  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        // If token is valid, redirect to home
        if (decodedToken.exp > currentTime) {
          navigate("/");
        } else {
          // If token is expired, remove it from localStorage
          localStorage.removeItem("accessToken");
        }
      } catch (error) {
        // If token is invalid, remove it from localStorage
        localStorage.removeItem("accessToken");
      }
    }
  }, [navigate]);

  // Handle OTP countdown separately
  useEffect(() => {
    if (isOtpSent) {
      startCountdown();
    }

    return () => {
      // Cleanup interval when the component is unmounted
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }
    };
  }, [isOtpSent]);

  // Function to start or restart the countdown
  const startCountdown = () => {
    // Clear any existing interval
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
    }
    // Reset the timer to 10 seconds
    setTimer(10);
    setCanResendOtp(false);

    // Start a new countdown
    countdownRef.current = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer === 1) {
          clearInterval(countdownRef.current); // Stop the countdown when timer reaches 0
          setCanResendOtp(true); // Enable the resend button
        }
        return prevTimer - 1;
      });
    }, 1000);
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/users/login`, { mobileNumber, userType: "accessUser" });

      if (response.status === 200) {
        setError(false);
        setIsOtpSent(true); // Start the OTP process
        setMessage("OTP sent successfully. Please check your messages.");
        startCountdown(); // Start the countdown
      } else {
        setError(true);
        setMessage("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      setError(true);
      setMessage(error.response?.data?.error || "An error occurred");
    }
  };

  const handleResendOtp = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/users/login`, { mobileNumber, userType: "accessUser" });

      if (response.status === 200) {
        setError(false);
        setMessage("OTP resent successfully. Please check your messages.");
        startCountdown(); // Restart the countdown when OTP is resent
      } else {
        setError(true);
        setMessage("Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      setError(true);
      setMessage(error.response?.data?.error || "An error occurred");
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/users/verify-otp`,
        {
          userType: "accessUser",
          mobileNumber,
          inputOtp: otp,
        },
        { withCredentials: true }
      );


      if (response.status === 200) {
        localStorage.setItem("accessToken", response.data.data.access_token);
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("permissions", JSON.stringify(response.data.data.permissions));
        localStorage.setItem("userType", "accessUser");
        toast.success("Login successful!"); //toast message for success
        window.location.href = "/";
      } else {
        setError(true);
        setMessage("Invalid OTP. Please try again.");
        toast.error("Invalid OTP. Please try again."); //toast message for error
      }
    } catch (error) {
      setError(true);
      setMessage(error.response?.data?.error || "An error occurred");
      toast.error(error.response?.data?.error || "An error occurred"); // toast for error
    }
  };

  return (
    <div className="login-body">
      <div className="logo-container">
        <img src={logo} alt="Logo" className="logo" />
      </div>
      <h1>Login</h1>
      <div className="login-page">
        <div className="form">
          {!isOtpSent ? (
            <form className="login-form" onSubmit={handleSendOtp}>
              <input type="tel" placeholder="Enter mobile number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} required />
              <button type="submit">Send OTP</button>
            </form>
          ) : (
            <form className="login-form" onSubmit={handleVerifyOtp}>
              <input type="tel" placeholder="Enter mobile number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} required disabled />
              <input type="text" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} required />
              <button type="submit">Verify OTP</button>
              {canResendOtp ? (
                <a align="center" href="#" onClick={handleResendOtp}>
                  Resend OTP
                </a>
              ) : (
                <p>Resend OTP in {timer} seconds</p>
              )}
            </form>
          )}
          {message && <p className={`message ${error ? "error" : ""}`}>{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default Login;
